import { ApiEndpointBuilder } from "@/services/api/types";

const declineUserInvitationEndpoint = (builder: ApiEndpointBuilder) => {
  return builder.mutation<string, { invitationId: string; tenantId: string }>({
    query: ({ invitationId, tenantId }) => ({
      url: `/invitations/${invitationId}/decline`,
      method: "PUT",
      headers: {
        "x-tenant": tenantId,
      },
    }),
    invalidatesTags: [
      { type: "userInvitations", id: "LIST" },
      { type: "usersInvitationsList" },
    ],
  });
};

export default declineUserInvitationEndpoint;
